/**
 * Students
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageStudentsComponent,
  AsyncAddStudentComponent,
  AsyncModifyStudentComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageStudentsComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddStudentComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyStudentComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
